import { render, staticRenderFns } from "./PagamentosExtra.vue?vue&type=template&id=204d8ed8&"
import script from "./PagamentosExtra.vue?vue&type=script&lang=js&"
export * from "./PagamentosExtra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports